import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function EditorialFooter() {
  const { t } = useTranslation();
  return (
      <footer className="about-footer about-wrap"><Link className="about-wordmark" to="/">LERAVYN</Link><span>© {new Date().getFullYear()} Leravyn</span><Link className="about-text-link" to="/contact">{t("nav.contact")}<ArrowUpRight size={16} aria-hidden="true" /></Link></footer>
  );
}
